/* eslint-disable */
import { CropPortrait } from '@material-ui/icons';
import { React, Fragment, Component } from 'react';
import Button from '@material-ui/core/Button';
// import Typography from '@material-ui/Typography';
// import Breadcrumbs from '@material-ui/Breadcrumbs';
// import Link from '@material-ui/Link';

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";

// function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
//   event.preventDefault();
//   console.info('You clicked a breadcrumb.');
// }
import moment from 'moment';

import DataTable from 'react-data-table-component';
import Select from 'react-select'

import Spinner from 'components/Spinner.js';

import * as R from 'ramda';

// const columns = [
//   {
//     name: 'Site',
//     selector: row => row.locncode,
//     sortable: true,
//   },
//   {
//     name: 'Role',
//     selector: row => row.role,
//     sortable: true,
//   },
// ];

export default class PermissionList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTable: false,
      showSpinner: true,
      showSelect: false,
      permission: null,
      role: null,
      rolePermissions: [],
      permissions: [],
      //data: []
    };
  }

  componentDidMount() {
    this.loadRolePermissions();
    this.loadPermissions();
  }

  loadRolePermissions = () => {
    this.setState({
      showTable: false,
    });

    var $this = this;
    fetch('/api/shared/roles/permissions/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({ role_id: $this.props.role_id })
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          $this.setState({
            //data: data.data.roles,
            rolePermissions: data.data.permissions.map(p => ({
              label: p.display_name,
              value: p.permission_id
            })),
            showSpinner: false,
            //showTable: true
          });
        }
        else {
          $this.setState({
            showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  loadPermissions = () => {
    var $this = this;
    fetch('/api/shared/permissions/list', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({})
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          $this.setState({
            permissions: data.data.permissions,
            // showSpinner: false,
            // showTable: true
          });
        }
        else {
          $this.setState({
            //showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          //showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  // handleRowClick = (row) => {
  //   if (confirm(`Remove role ${row.role} from site ${row.locncode}?`)) {
  //     var $this = this;
  //     fetch('/api/shared/users/roles/remove', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json'
  //         // 'Content-Type': 'application/x-www-form-urlencoded',
  //       },
  //       body: JSON.stringify({
  //         "userId": $this.props.role_id,
  //         "locncode": row.locncode,
  //         "roleId": row.role_id
  //     })
  //     })
  //     .then(response => response.json())
  //     .then(data => {
  //       console.log(data);
  //       if (data.status.success) {
  //         this.loadRolePermissions();
  //       }
  //       else {
  //         $this.setState({
  //           showSpinner: false
  //         });
  //         alert('There was an error. Please try again later.')
  //       }
  //     }).catch(() => {
  //       $this.setState({
  //         showSpinner: false
  //       });
  //       alert('There was an error. Please try again later.')
  //     });
  //   }
  // }

  handleRoleAddRemove = (permissionId, add) => {
    this.setState({
      showSpinner: true
    });
    if (true || confirm(`<replace>`)) {
      var $this = this;
      fetch(`/api/shared/roles/permissions/${add ? 'add' : 'remove'}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify({
          roleId: $this.props.role_id,
          permissionId
      })
      })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          this.loadRolePermissions();
        }
        else {
          $this.setState({
            showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
    }
  }

  handlePermissionChange = (role) => {
    if (this.state.rolePermissions.length > role.length)
    {
      var permissions = R.difference(this.state.rolePermissions, role);
      if (permissions.length > 0)
        this.handleRoleAddRemove(permissions[0].value, false);
    }
    else if (this.state.rolePermissions.length < role.length)
    {
      var permissions = R.difference(role, this.state.rolePermissions);
      if (permissions.length > 0)
        this.handleRoleAddRemove(permissions[0].value, true);
    }
    //alert(JSON.stringify(role))
  }

  render ()
  {
    console.log('rolePermissions' + JSON.stringify(this.state.rolePermissions));
    return (
      <Fragment>
        { !this.state.showSpinner && this.state.permissions.length > 0 ?
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={2}>
              Permissions:
            </GridItem>
            <GridItem xs={12} sm={12} md={10}>
              <Select name="role" defaultValue={this.state.rolePermissions}
                isMulti
                onChange={this.handlePermissionChange}
                options ={this.state.permissions.map(e => 
                  { return {
                    value: e.id,
                    label: e.display_name
                  };}
                ) }
              />
            </GridItem>
          </GridContainer><br/>
        </div>
        : <Spinner/> }
      </Fragment>
    );
  }
}
